import {
  Rotationsplan_BerufeByStandortgruppenIdQuery,
  Rotationsplan_BerufeByStandortgruppenIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { BERUFE_BY_STANDORTGRUPPEN_ID } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useBerufe/graphql/queries';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';

export function useBerufe(standortGruppenId: string): {
  berufe: Beruf[];
  error?: string;
} {
  const result = useSuspenseQuery<
    Rotationsplan_BerufeByStandortgruppenIdQuery,
    Rotationsplan_BerufeByStandortgruppenIdQueryVariables
  >(BERUFE_BY_STANDORTGRUPPEN_ID, {
    variables: { standortGruppenId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { berufe: [] };
  }

  return {
    berufe: result.data.mitarbeiter_standortgruppeById.berufe.map(
      (beruf) =>
        new Beruf({
          id: beruf.id,
          name: beruf.name,
          markierung: beruf.markierung,
          abkuerzung: beruf.abkuerzung ?? '',
          istAusbildung: beruf.istAusbildung,
        }),
    ),
  };
}
